import { Backend } from "../web-apis/backends";
import { UserPermissions } from "../web-apis/user-permissions";
import Immerable from "./immerable";

/*
    User class
    User is currently being stored in two different places: here and in rtviewer-api-client.tsx
    (the RTViewerAPIClient class, exported as a singleton rtViewerApiClient). These classes
    should eventually be refactored so that RTViewerAPIClient is only concerned with calling
    the RTViewer API, not with storing user information.

    The current workaround for this is that this class is considered the single source of
    truth. Updating this class in the redux store will cause redux sagas functions to
    automatically update rtViewerApiClient with matching fields (using 
    RTViewerAPIClient.updateUser).
*/

export class User extends Immerable {
    public isAuthenticated: boolean;
    public username: string;
    public email: string;
    public permissions: UserPermissions;
    public currentBackend: Backend | null;

    /** 
     * Show (or not) information that may identify patient and/or originating clinic in
     * places like the splash screen or RTViewer main view. This should generally be set 
     * to false when e.g. screen-sharing your session of RTViewer.
     */
    public showPatientInfo: boolean;

    constructor() {
        super();
        this.isAuthenticated = false;
        this.username = '';
        this.email = '';
        this.permissions = new UserPermissions();

        // null -> use default
        this.currentBackend = null;

        // TODO: is this a good default?
        this.showPatientInfo = false;
    }

    setBasicDetails(username: string, email: string) {
        this.username = username;
        this.email = email;
        this.isAuthenticated = true;
    }

    setPermissions(permissions: UserPermissions) {
        this.permissions = permissions;
    }

    allowConfiguration() {
        // currently, as the log out functionality is embedded into the user settings dialog, we allow everyone to access it
        return true;
    }
}